import { app } from '../shared';

export const removeUser = async (token) => {
  return app.service('user-credentials').remove(token);
};
